import { basePixelAmount } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

export default {
    css: css`
        html {
            font-size: ${basePixelAmount}px;
        }

        body {
            ${x => x.theme.typography.body.css};
        }

        /* -- CMS Adjustments ----------------------------------------------------------*/

        [class^="AddContainer"] [class^="IconContainer"] i {
            color: inherit;
        }

        [data-zone-single] [class^="AddContainer"]:not(:first-child) {
            display: none;
        }
    `,
} as Styleguide["globalStyle"];
